import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import PDFPositionTool from "../components/PDFPositionTool";
import "../styles/Devis.css";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";

const PdfToolPage: React.FC = () => {
  const pdfOptions = {
    "MonDevis.pdf": {
      url: "../pdfs/fdaRegistrationInvoice.pdf", // Confirmer le chemin correct du PDF Mon Devis
      fields: { // Remplacer par la structure correcte des champs pour Mon Devis
        devis: ["amount", "companyId", "contact", "date", "id", "updatedAt"],
        opportunities: ["amount", "companyId", "contact", "createdAt", "date", "pu", "qte", "ttc", "type"],
        society: ["siret", "name", "address", "city", "postalCode", "country"]
      },
      firestoreDoc: "pdfPositions" // Confirmer le nom de la collection Firestore
    }
  };

  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate('/login');
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
    }
  };

  return (
    <div className="devis-container">
      <Header 
        isAuthenticated={true} 
        onLoginClick={() => navigate('/login')} 
        onHomeClick={() => navigate('/')} 
        onLogoutClick={handleLogout}
      />

      <div style={{ 
        display: "flex", 
        gap: "40px", 
        alignItems: "flex-start", 
        flexWrap: "wrap",
        padding: "20px",
        maxWidth: "1400px",
        margin: "0 auto",
        boxShadow: "none"
      }}>
        <div style={{ 
          flex: 2,
          minWidth: "800px",
          backgroundColor: "#fff",
          borderRadius: "8px",
          padding: "20px"
        }}>
          <PDFPositionTool pdfOptions={pdfOptions} />
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PdfToolPage;